import { useTranslation } from 'react-i18next'

import { ArrowSquareOutIcon } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import { Card, CardTitle, GiftReturnChip, Link } from '@reveni-io/reveni-ui'

import CustomerDetailInfo from '@/common/components/CustomerDetailInfo/CustomerDetailInfo.jsx'
import { userPermissions } from '@/common/constants.js'
import useUserPermissions from '@/common/hooks/useUserPermissions/useUserPermissions.js'
import routes from '@/Router/routes.constants.js'

import CustomerDetailMenu from './CustomerDetailMenu/CustomerDetailMenu.jsx'
import * as Styles from './styles.js'

const CustomerDetailCard = ({
  name,
  email,
  phone,
  address,
  onEditCustomer,
  onContactCustomer,
  allowSendEmail,
  showCustomerMenu = true,
  storeId,
  isGiftReturn,
  allowsUpdateCustomer,
}) => {
  const theme = useTheme()
  const { t } = useTranslation()
  const { hasPermission } = useUserPermissions()

  const getSeeTransactionsLink = () => {
    return `${routes.transactionsPage}?query=${encodeURIComponent(email)}&page=1&orderBy=-completed_at`
  }

  return (
    <>
      <Card showBorder={false}>
        <CardTitle marginBottom={isGiftReturn && theme.spacing.sp8}>
          {t('Datos del cliente')}
          {showCustomerMenu && (
            <CustomerDetailMenu
              onEditCustomer={onEditCustomer}
              allowEditCustomer={allowsUpdateCustomer && hasPermission(userPermissions.editCustomerData, storeId)}
              onContactCustomer={onContactCustomer}
              allowSendEmail={allowSendEmail}
            />
          )}
        </CardTitle>
        {isGiftReturn && (
          <Styles.GiftReturnChipContainer>
            <GiftReturnChip isRecipient />
          </Styles.GiftReturnChipContainer>
        )}
        <Styles.Container>
          <CustomerDetailInfo
            nameLabel="Nombre cliente"
            customerProfile={{ first_name: name, email, phone }}
            address={address}
          />
          <Styles.LinkContainer>
            <Link target="_blank" href={getSeeTransactionsLink()}>
              {t('Ver transacciones')} <ArrowSquareOutIcon size={24} />
            </Link>
          </Styles.LinkContainer>
        </Styles.Container>
      </Card>
    </>
  )
}

export default CustomerDetailCard
